// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.c86VvZedGnwmj0e8SNV4{width:100%;height:100%;padding:0 16px;position:relative}.c86VvZedGnwmj0e8SNV4 .c6ma1A2pEcRf2TuCuke8{width:100%;height:100%;position:relative}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tableContainer": `c86VvZedGnwmj0e8SNV4`,
	"table": `c6ma1A2pEcRf2TuCuke8`
};
export default ___CSS_LOADER_EXPORT___;
